import Menu from '../components/Menu';

const Header = () => {
  return <Menu />;
};

export default Header;
